/* eslint-disable @typescript-eslint/no-explicit-any */
import { ErrorMessage, Field, Form, Formik, FormikHelpers, FormikValues } from 'formik';
import React, { FC, ReactNode, ReactElement } from 'react';
import { SchemaOf } from 'yup';

export interface IFormField {
    fieldName: string;
    value: string;
    component?: FC | ReactNode | ReactElement;
    placeholder?: string;
    type?: string;
    autocomplete?: string;
    disabled?: boolean;
}

interface IFormProps<T, Q> {
    initialValues: FormikValues & T;
    inputsSchema: SchemaOf<Q>;
    inputFields: IFormField[];
    handleSubmit: (values: any, formikHelpers: FormikHelpers<any>) => void | Promise<any>;
    cancelClick?: () => void;
    submitButtonText?:string;
    cancelButtonText? :string;
    enableLabelValue?: boolean;
    enableReinitialize: boolean;
    enableDefaultSubmitButton?: boolean;
    rootClassname: string;
}

const FormikWrapper: <T, Q>(props: IFormProps<T, Q>) => React.ReactElement<IFormProps<T, Q>> = (props) => {
  const {
    cancelClick,
    handleSubmit,
    initialValues,
    inputsSchema,
    inputFields,
    submitButtonText,
    cancelButtonText,
    enableLabelValue,
    enableReinitialize,
    enableDefaultSubmitButton,
    rootClassname,
  } = props;
  return (
    <div>
      <Formik
        enableReinitialize={enableReinitialize}
        initialValues={initialValues}
        validationSchema={() => inputsSchema}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form className={rootClassname}>
            {inputFields.map((field: IFormField, index: number) =>
              <div key={index}>
                <label htmlFor={field.fieldName}>
                  {enableLabelValue && field.value}
                  <Field
                    type={field.type}
                    id={field.fieldName}
                    name={field.fieldName}
                    placeholder={field.placeholder}
                    component={field.component}
                    autoComplete={field.autocomplete}
                    disabled={field.disabled}
                  />
                </label>
                <ErrorMessage
                  name={field.fieldName}
                  render={errorMsg =>
                    <span className='question-action-form-error-message'>
                      {errorMsg}
                    </span>
                  }
                />
              </div>
            )}
            <div className='question-action-form-button-group'>
              {cancelClick && (
                <button
                  className='cancel-button'
                  onClick={cancelClick}
                >
                  {cancelButtonText ?? 'Cancel'}
                </button>)}
              {enableDefaultSubmitButton && (
                <button
                  className='submit-button'
                  type='submit'
                  disabled={!(formik.isValid && formik.dirty)}
                >
                  {submitButtonText ?? 'Save'}
                </button>)}
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export { FormikWrapper };
